var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9349 2.20871C13.6536 1.9275 13.2722 1.76953 12.8744 1.76953C12.4767 1.76953 12.0952 1.9275 11.8139 2.20871L10.5802 3.44321L14.5574 7.42046L15.7912 6.18746C15.9305 6.04816 16.0411 5.88278 16.1165 5.70075C16.1919 5.51872 16.2307 5.32362 16.2307 5.12659C16.2307 4.92955 16.1919 4.73445 16.1165 4.55242C16.0411 4.37039 15.9305 4.20501 15.7912 4.06571L13.9349 2.20871ZM13.4969 8.48096L9.51968 4.50371L2.89343 11.13L2.08643 15.915L6.87143 15.1072L13.4969 8.48096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.5bc03089bcdf7ba9ee4753074dd26948.svg";
export { ForwardRef as ReactComponent };